import { useStore, State } from 'store';

const selector = (state: State) => {
  return state.startWorkflow.steps.provideFiles.fileMap;
};

export default function useSelectedFileMap() {
  return useStore(selector);
}
